import styled from 'styled-components';
import { ThemeColours } from '../../../../../../../common/styles/ThemeColours';
import {
  FontWeight,
  ZIndex,
  FontSize,
  Breakpoint,
} from '../../../../../../../common/styles/constants';
import { onMobile } from '../../../../../../../common/styles/onMobile';

export const Frame = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column-reverse;
`;

export const Overlay = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  margin-bottom: -14px;
  margin-inline-end: -8px;
  margin-top: 0;
  order: 0;
  width: 80px;
  z-index: ${ZIndex.NORMAL};

  ${Breakpoint.SMALL} {
    margin-inline-end: -8px;
    width: 104px;
  }
`;

export const Label = styled.div`
  background-color: #ffc043;
  border-radius: 4px;
  color: ${ThemeColours.warning700};
  font-size: ${FontSize.EXTRA_SMALL};
  font-weight: ${FontWeight.SEMI_BOLD};
  line-height: 18px;
  padding: 2px 4px;
`;

export const Corner = styled.div`
  border: solid 8px transparent;
  border-left: solid 8px ${ThemeColours.warning700};
  border-top: solid 8px ${ThemeColours.warning700};
  box-sizing: border-box;
  height: 16px;
  width: 16px;

  ${onMobile} {
    border-width: 4px;
    height: 8px;
    width: 8px;
  }
`;
